import { ref } from 'vue'
import { collection, query, where, getDocs, orderBy, limit } from 'firebase/firestore'
import { db } from '@/firebase/firebase'

export function usePartnerDashboard() {
  const loading = ref(false)
  const error = ref(null)

  // 상단 배너 조회
  const dashboardBanners = ref([])
  const loadDashboardBanners = async () => {
    try {
      const q = query(
        collection(db, 'partnerDashboardBanners'),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      )
      const snapshot = await getDocs(q)
      dashboardBanners.value = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (err) {
      console.error('대시보드 배너 로드 실패:', err)
      error.value = err.message
    }
  }

  // 업데이트 노트 조회
  const updates = ref([])
  const loadUpdates = async (limitCount = 5) => {
    try {
      const q = query(
        collection(db, 'partnerUpdates'),
        where('isActive', '==', true),
        orderBy('createdAt', 'desc'),
        limit(limitCount)
      )
      const snapshot = await getDocs(q)
      updates.value = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (err) {
      console.error('업데이트 로드 실패:', err)
      error.value = err.message
    }
  }

  // 정사각형 배너 조회
  const squareBanners = ref([])
  const loadSquareBanners = async () => {
    try {
      const q = query(
        collection(db, 'partnerSquareBanners'),
        where('isActive', '==', true),
        orderBy('order', 'asc')
      )
      const snapshot = await getDocs(q)
      squareBanners.value = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }))
    } catch (err) {
      console.error('정사각형 배너 로드 실패:', err)
      error.value = err.message
    }
  }

  // 모든 데이터 한번에 로드
  const loadAll = async () => {
    loading.value = true
    error.value = null
    try {
      await Promise.all([
        loadDashboardBanners(),
        loadUpdates(),
        loadSquareBanners()
      ])
    } catch (err) {
      error.value = err.message
    } finally {
      loading.value = false
    }
  }

  // 업데이트 유형 라벨
  const getUpdateTypeLabel = (type) => {
    const labels = {
      feature: '신기능',
      improvement: '개선',
      fix: '버그수정',
      notice: '안내'
    }
    return labels[type] || type
  }

  // 업데이트 유형 배지 클래스
  const getUpdateTypeBadgeClass = (type) => {
    const classes = {
      feature: 'bg-blue-100 text-blue-700',
      improvement: 'bg-emerald-100 text-emerald-700',
      fix: 'bg-amber-100 text-amber-700',
      notice: 'bg-violet-100 text-violet-700'
    }
    return classes[type] || 'bg-slate-100 text-slate-600'
  }

  return {
    loading,
    error,
    dashboardBanners,
    updates,
    squareBanners,
    loadDashboardBanners,
    loadUpdates,
    loadSquareBanners,
    loadAll,
    getUpdateTypeLabel,
    getUpdateTypeBadgeClass
  }
}
